import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
const InjectMassage = props => _jsx(FormattedMessage, Object.assign({}, props));
export default injectIntl(InjectMassage, {
    withRef: false
});
